export default "__VITE_ASSET__Be3Uhml4__"